module.exports = __webpack_public_path__ + "fonts/AvertaStd-BoldItalic.eot";